<div style="padding: 24px;">
  <div *ngIf="loading">Signing you in...</div>
  <div *ngIf="!loading && error" style="color: #b00020;">{{ error }}</div>
</div>